import { useEffect, useState } from 'react';
import { Button } from '../ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { caAPI, saveBlob } from '../../lib/complianceAutoAPI';

const Rows = ({ title, rows, target, tid }) => (
  <div className="rounded-md border overflow-x-auto" data-testid={tid}><p className="text-xs font-medium p-2">{title}</p>
    <Table className="text-xs"><TableHeader><TableRow>{['', 'On time', 'Late', 'Overdue', 'Not yet due', '% on time', `Target ${target}%`].map((h) => <TableHead key={h}>{h}</TableHead>)}</TableRow></TableHeader>
      <TableBody>{rows.map((g) => <TableRow key={g.key} data-testid={`${tid}-${g.key}`}><TableCell>{g.label}</TableCell><TableCell>{g.on_time}</TableCell><TableCell>{g.late}</TableCell>
        <TableCell>{g.overdue}</TableCell><TableCell>{g.not_yet_due}</TableCell><TableCell>{g.pct_on_time ?? '—'}</TableCell>
        <TableCell className={g.meets_target === false ? 'text-red-700' : g.meets_target ? 'text-emerald-700' : ''}>{g.meets_target === null ? '—' : g.meets_target ? 'met' : 'below'}</TableCell></TableRow>)}</TableBody></Table></div>);

export const PerformancePanel = ({ fy, ot }) => {
  const [d, setD] = useState(null);
  useEffect(() => { caAPI.performance(fy, ot).then(setD).catch(() => {}); }, [fy, ot]);
  if (!d) return null;
  return (
    <div className="space-y-2" data-testid="ca-performance">
      <div className="flex items-center gap-2"><h3 className="text-sm font-semibold">Lodgment performance</h3>
        <Button size="sm" variant="outline" className="h-7" onClick={() => caAPI.exportPerformance(fy, ot).then((b) => saveBlob(b, 'compliance-performance.csv'))} data-testid="ca-performance-export">Export CSV</Button></div>
      <div className="grid md:grid-cols-2 gap-2">
        <Rows title="By obligation" rows={d.by_obligation} target={d.target_pct} tid="ca-perf-ob" />
        <Rows title="By staff" rows={d.by_staff} target={d.target_pct} tid="ca-perf-staff" />
      </div>
      <p className="text-xs text-muted-foreground" data-testid="ca-perf-exceptions">Open exceptions by type: {Object.entries(d.exceptions_by_type).map(([k, v]) => `${k} ${v}`).join(' · ') || 'none'}</p>
    </div>
  );
};
